import WidgetSettings from './WidgetSettings';
export default WidgetSettings;
export { default as HeaderWidgetSettings } from './HeaderWidgetSettings';
export { default as StatusWidgetSettings } from './StatusWidgetSettings';
export { default as FooterWidgetSettings } from './FooterWidgetSettings';
export { default as BannerWidgetSettings } from './BannerWidgetSettings';
export { default as ProductsWidgetSettings } from './ProductsWidgetSettings';
